import { render, staticRenderFns } from "./homePage2.vue?vue&type=template&id=ffa6d9fc&scoped=true"
import script from "./homePage2.vue?vue&type=script&lang=js"
export * from "./homePage2.vue?vue&type=script&lang=js"
import style0 from "./homePage2.vue?vue&type=style&index=0&id=ffa6d9fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa6d9fc",
  null
  
)

export default component.exports